import React, { useRef, useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const GalleryField = ({ tid, value = [], onChange, uploadPath = "/admin/upload" }) => {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const upload = async (files) => {
    const list = Array.from(files || []).filter((f) => f.type.startsWith("image/"));
    if (!list.length) return;
    setBusy(true);
    const urls = [];
    for (const file of list) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post(uploadPath, fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      } catch (err) {
        toast.error(`${file.name}: ${err.response?.data?.detail || "upload failed"}`);
      }
    }
    if (urls.length) onChange([...(value || []), ...urls]);
    setBusy(false);
  };

  return (
    <div className="flex flex-wrap gap-3" data-testid={tid}>
      {(value || []).map((url, i) => (
        <div key={url + i} className="relative w-24 h-24 rounded-xl overflow-hidden border border-[color:var(--line)] group">
          <img src={url} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`${tid}-remove-${i}`}
            className="absolute top-1 right-1 p-1 rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity"><X size={12} /></button>
        </div>
      ))}
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${tid}-add`}
        className="w-24 h-24 rounded-xl border-2 border-dashed border-[color:var(--line)] hover:border-[color:var(--ocean)] grid place-items-center text-[color:var(--ink-2)] text-xs disabled:opacity-50">
        <div className="flex flex-col items-center gap-1"><Plus size={18} />{busy ? "Uploading…" : "Add photos"}</div>
      </button>
      <input ref={inputRef} data-testid={`${tid}-file`} type="file" accept="image/*" multiple className="hidden" onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
    </div>
  );
};
